<div class="container">
    <div class="row g-3">
        <div class="col-xl-8 col-lg-8 col-md-6 col-12">
            <div class="d-flex">
                <h2 class="m-0">
                    ตั้งค่ารางวัล
                </h2>
                <button class="btn btn-primary ms-md-2 ms-auto" (click)="addReward()">เพิ่มรางวัล</button>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-12 text-md-end">
            <!-- <div class="input-icon-start">
                <input type="text" class="form-control" placeholder="ค้นหารางวัล">
                <span class="material-symbols-outlined">
                    search
                </span>
            </div> -->
            <app-filter [text]="'ค้นหารางวัล'" (updateValue)="getReward($event)"></app-filter>
        </div>
    </div>
    <br>
    <div class="row g-3">
        <div class="col-12">
            <table class="table align-middle" *ngIf="rewardItems">
                <thead>
                    <tr>
                        <th class="d-none d-lg-table-cell d-xl-table-cell d-md-table-cell">รางวัล</th>
                        <th class="d-none d-lg-table-cell d-xl-table-cell d-md-table-cell"></th>
                        <th class="d-none d-lg-table-cell d-xl-table-cell d-md-table-cell">แต้มที่ใช้แลกของรางวัล</th>
                        <th class="d-none d-lg-table-cell d-xl-table-cell d-md-table-cell">จำนวนรางวัลคงเหลือ</th>
                        <th class="d-none d-lg-table-cell d-xl-table-cell d-md-table-cell"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let rw of rewardItems">
                        <td [width]="48">
                            <img [src]="rw.Image" alt="">
                        </td>
                        <td>
                            <b>{{rw.Name}}</b>
                            <br>
                            <div class="detail d-block d-md-none">

                                <span>ประเภทรางวัล:
                                    <span *ngIf="rw.Type == 'discount'">ส่วนลด</span>
                                    <span *ngIf="rw.Type != 'discount'">สิ่งของ</span>
                                </span>
                                <br>
                                <span>วันที่หมดอายุ:
                                    {{rw.Expire_start | date:'dd/MM/yyyy'}} -
                                    {{rw.Expire_end | date:'dd/MM/yyyy'}}</span>
                            </div>

                        </td>
                        <td class="d-none d-lg-table-cell d-xl-table-cell d-md-table-cell">{{rw.Point}} คะแนน</td>
                        <td class="d-none d-lg-table-cell d-xl-table-cell d-md-table-cell">
                            <span *ngIf="rw.Deduct == 1">{{rw.Remaining}}</span>
                            <span *ngIf="rw.Deduct == 0">ปิดการตัดจำนวน</span>
                        </td>
                        <td class="text-end">
                            <!-- <button class="btn btn-cancel w-100" (click)="deleteReward(rw)">
                                ลบ</button>
                            <button class="btn btn-primary w-100" (click)="viewReward(rw)">แก้ไข</button> -->
                            <span class="material-icons pointer" (click)="viewMenu(rw,menu,$event)">
                                more_vert
                            </span>
                            <p-menu [model]="setitem" #menu [popup]="true"></p-menu>
                        </td>
                    </tr>
                </tbody>
            </table>
            <app-pagination *ngIf="rewardItems" [page]="1" [pageTotal]="pageTotal"
                (updatePage)="getReward($event)"></app-pagination>
        </div>
    </div>
</div>


<p-dialog [header]="message" [(visible)]="manageReward" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '50vw' }" [draggable]="false"
    [resizable]="false" [formGroup]="formReward" (onHide)="clearEvent()">
    <ng-container *ngIf="manageReward">
        <div class="row g-3">
            <!-- <div class="col-12 mb-3">
            <app-upload-file (FileUpload)="uploadFile($event)">
                <div class="box-image" *ngIf="!viewImage && !formReward.value['Image']">
                    <p>รูปรางวัล</p>
                </div>
                <img [src]="viewImage" width="100%" *ngIf="viewImage && addStatus">
                <img [src]="viewImage" width="100%" *ngIf="viewImage  && updateStatus">
                <img [src]="formReward.value['Image']" width="100%"
                    *ngIf="!viewImage && formReward.value['Image'] && updateStatus">
            </app-upload-file>
        </div> -->
            <div class="col-12 mb-3 image text-center">
                <app-upload-file [action]="imageAction" (FileUpload)="uploadFile($event)">
                    <div class="box-image pointer" *ngIf="!viewImage && !formReward.value['Image']">
                        <br><br>
                        <div class="icon-box">
                            <span class="material-symbols-outlined">
                                upload
                            </span>
                        </div>
                        <br>
                        อัพโหลดรูปภาพ
                        <br>
                        ขนาดไฟล์ไม่เกิน 1 MB
                    </div>
                    <img class="pointer" [src]="viewImage" width="100%" *ngIf="viewImage && addStatus">
                    <img class="pointer" [src]="viewImage" width="100%" *ngIf="viewImage  && updateStatus">
                    <img class="pointer" [src]="formReward.value['Image']" width="100%"
                        *ngIf="!viewImage && formReward.value['Image'] && updateStatus">
                </app-upload-file>
            </div>
            <div class="col-12">
                <p>ชือรางวัล <span class="text-danger">*</span></p>
                <input type="text" class="form-control" formControlName="Name"
                    placeholder="ตัวอย่างเช่น ส่วนลด 100 บาท">
            </div>
            <div class="col-12">
                <p>ประเภทรางวัล <span class="text-danger">*</span></p>
                <select class="form-select" formControlName="Type">
                    <option value="">เลือกประเภท</option>
                    <option value="discount">ส่วนลด</option>
                    <option value="things">สิ่งของ</option>
                </select>
            </div>
            <ng-container *ngIf="formReward.value['Type'] == 'discount'">
                <div class="col-12">
                    <p>ประเภทส่วนลด <span class="text-danger">*</span></p>
                    <select class="form-select" formControlName="DisType">
                        <option value="">เลือกประเภทส่วนลด</option>
                        <option value="amount">ส่วนลดแบบระบุจำนวน</option>
                        <option value="percentage">ส่วนลดแบบ %</option>
                    </select>
                </div>
                <div class="col-12" *ngIf="formReward.value['DisType']">
                    <p *ngIf=" formReward.value['DisType']=='amount'">จำนวนส่วนลดกี่บาท</p>
                    <p *ngIf=" formReward.value['DisType']=='percentage'">ส่วนลดกี่ %</p>
                    <input type=" number" class="form-control" formControlName="DisAmount">
                </div>
            </ng-container>
            <div class="col-12">
                <p>คะแนนที่ใช้แลกรางวัล</p>
                <input type="number" class="form-control" formControlName="Point" placeholder="ต้องใช้กี่คะแนนเพื่อแลก">
            </div>
            <div class="col-12">
                <p>อธิบายเพิ่มเติม</p>
                <textarea class="form-control explain" formControlName="Description"
                    placeholder="อธิบายเพิ่มเติม"></textarea>
                <!-- <input type="text" class="form-control" formControlName="Condition"> -->
            </div>
            <div class="col-12">
                <p>เงื่อนไขการใช้สิทธิ์</p>
                <textarea class="form-control termsuse" formControlName="Condition" placeholder="อธิบายข้อกำหนดและเงื่อนไขการใช้สิทธิ์
"></textarea>
                <!-- <input type="text" class="form-control" formControlName="Condition"> -->
            </div>
            <div class="col-12">
                <!-- <input type="checkbox" [checked]="formReward.value['Deduct'] == 1" (click)="deduct()"> -->
                <app-checkbox [InputValue]="formReward.value['Deduct'] || 0"
                    (updateValue)="deduct($event)">หักจำนวนของรางวัล</app-checkbox>

            </div>
            <div class="col-6" *ngIf="formReward.value['Deduct'] == 1">
                <p>จำนวนคงเหลือ</p>
                <input type="number" class="form-control" formControlName="Remaining">
            </div>
        </div>
        <br>
        <div class="row g-3">
            <!-- <div class="col-12">
                <app-checkbox [InputValue]="formReward.value['Expire'] || 0"
                    (updateValue)="expire($event)">วันที่หมดอายุ</app-checkbox>
            </div> -->
            <!-- {{formReward.value['Expire']}} -->
            <ng-container *ngIf="formReward.value['Expire'] == 1">
                <div class="col-6">
                    <p>วันที่เริ่ม</p>
                    <div class="calendar-icon-start">
                        <p-calendar styleClass="w-100" formControlName="Expire_start_edit" dateFormat="dd/mm/yy"
                            (onSelect)="updateExpire($event,'start')" [touchUI]="true"></p-calendar>
                        <span class="material-symbols-outlined icon">
                            calendar_today
                        </span>
                    </div>

                </div>
                <div class="col-6">
                    <p>วันที่สิ้นสุด</p>
                    <div class="calendar-icon-start">
                        <p-calendar styleClass="w-100" formControlName="Expire_end_edit" dateFormat="dd/mm/yy"
                            (onSelect)="updateExpire($event,'end')" [touchUI]="true"></p-calendar>
                        <span class="material-symbols-outlined icon">
                            calendar_today
                        </span>
                    </div>
                </div>
            </ng-container>

        </div>
        <div class="row">
            <div class="col-12 text-end mt-3">
                <button class="btn btn-primary me-3" *ngIf="addStatus" (click)="createReward()">
                    สร้างรางวัล
                </button>
                <button class="btn btn-primary me-3" *ngIf="updateStatus" (click)="updateReward()">
                    แก้ไขรางวัล
                </button>
                <button class="btn btn-cancel" (click)="clearEvent()">
                    ปิด
                </button>
            </div>
        </div>
    </ng-container>
</p-dialog>